import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { DisableIfNoGroupPermissionDirective } from '../../directives/disable-if-no-group-permission.directive';


@Component({
  selector: 'ag-action-cell-renderer-component',
  standalone: true,
  imports: [CommonModule, DisableIfNoGroupPermissionDirective],
  templateUrl: './action-cell-renderer.component.html',
  styleUrl: './action-cell-renderer.component.scss'
})


export class ActionCellRendererComponent<T> implements ICellRendererAngularComp {
  @Input() onDeleteAction: ((data: T) => void) = () => {};
  @Input() onEditAction: ((data: T) => void) = () => {};
  @Input() onDetailsAction: ((data: T) => void) = () => {};

  @Input() deleteLabel: string = 'Delete';
  @Input() editLabel: string = 'Edit';
  @Input() detailsLabel: string = 'Details';

  @Input() deleteIcon: string = 'bi-trash'; // Default Bootstrap icon classes
  @Input() editIcon: string = 'bi-pencil';
  @Input() detailsIcon: string = 'bi-eye';

  params: ICellRendererParams | undefined;

  agInit(params: ICellRendererParams): void {
    this.params = params;

     // Assign the functions from params.cellRendererParams to the inputs
     if (params.context?.onDeleteAction) {
      this.onDeleteAction = params.context.onDeleteAction;
    }

    if (params.context?.onEditAction) {
      this.onEditAction = params.context.onEditAction;
    }

    if (params.context?.onDetailsAction) {
      this.onDetailsAction = params.context.onDetailsAction;
    }

  }

  refresh(params: ICellRendererParams): boolean {
    return false;
  }

  onDelete(): void {
    if (confirm('Are you sure you want to delete this item?')) {
      this.onDeleteAction(this.params!.data as T);
    }
  }

  onEdit(): void {
    if (this.onEditAction && this.params) {
      this.onEditAction(this.params!.data as T);
    }
  }

  onDetails(): void {
    if (this.onDetailsAction && this.params) {
      this.onDetailsAction(this.params.value);
    }
  }
}
